import { useEffect } from 'react';

import { supabaseClient, useUser } from '@auth-v2';

import { FloorSettings, subscribeToFloorSettings } from '@data';
import { updateFloorSettings } from '@queries';

export const useSubscribeToFloorSettings = () => {
    const { data: user } = useUser();
    useEffect(() => {
        const subscription = subscribeToFloorSettings(supabaseClient, async (payload: FloorSettings) => {
            if (user?.id) updateFloorSettings(user.id, payload);
        });

        return () => {
            subscription.unsubscribe();
        };
    }, [user?.id]);
};
